// 投保方案
export const optionPlan = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '保障项目',
			prop: 'insuredItem',
			html: true,
		},
		{
			label: '方案一',
			prop: 'plan1',
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
		{
			label: '方案三',
			prop: 'plan3',
		},
		{
			label: '方案四',
			prop: 'plan4',
		},
		{
			label: '方案五',
			prop: 'plan5',
		},
	],
}

export const optionPlanDoor = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '保障项目',
			prop: 'insuredItem',
			html: true,
		},
		{
			label: '方案一',
			prop: 'plan1',
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
		{
			label: '方案三',
			prop: 'plan3',
		},
		{
			label: '方案四',
			prop: 'plan4',
		},
	],
}

// 团意险投保方案
export const optionPlanTy = {
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '保障项目',
			prop: 'insuredItem',
		},
		{
			label: '方案一',
			prop: 'plan1',
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
		{
			label: '方案三',
			prop: 'plan3',
		},
		{
			label: '方案四',
			prop: 'plan4',
		},
		{
			label: '方案五',
			prop: 'plan5',
		},
		{
			label: '方案六',
			prop: 'plan6',
		},
		{
			label: '方案七',
			prop: 'plan7',
		},
		{
			label: '方案八',
			prop: 'plan8',
		},
		{
			label: '方案九',
			prop: 'plan9',
		},
		{
			label: '方案十',
			prop: 'plan10',
		},
	],
}

// 安责险保险详情option
export const optionPlanAnZe = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '限额',
			prop: 'insuredItem',
		},
		{
			label: '类别',
			prop: 'plan0',
		},
		{
			label: '方案一',
			prop: 'plan1',
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
		{
			label: '方案三',
			prop: 'plan3',
		},
		{
			label: '方案四',
			prop: 'plan4',
		},
	],
}

// 泰康1-5类雇主险-option
export const optionPlanAnZeGZ = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	showHeader: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '',
			prop: 'plan0',
		},
		{
			label: '',
			prop: 'plan1',
		},
		{
			label: '',
			prop: 'plan2',
		},
		{
			label: '',
			prop: 'plan3',
		},
		{
			label: '',
			prop: 'plan4',
		},
		{
			label: '',
			prop: 'plan5',
		},
		{
			label: '',
			prop: 'plan6',
		},
		{
			label: '',
			prop: 'plan7',
		},
		{
			label: '',
			prop: 'plan8',
		},
		{
			label: '',
			prop: 'plan9',
		},
		{
			label: '',
			prop: 'plan10',
		},
		{
			label: '',
			prop: 'plan11',
		},
	],
}

// 美亚险投保方案
export const optionPlanMyB = {
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '保障利益',
			prop: 'insuredItem',
			width: 300,
		},
		{
			label: '各被保险人的保险金额（人民币：元）',
			children: [
				{
					label: '计划一',
					prop: 'plan1',
				},
				{
					label: '计划二',
					prop: 'plan2',
				},
				{
					label: '计划三',
					prop: 'plan3',
				},
				{
					label: '计划四',
					prop: 'plan4',
				},
				{
					label: '计划五',
					prop: 'plan5',
				},
				{
					label: '计划六',
					prop: 'plan6',
				},
				{
					label: '计划七',
					prop: 'plan7',
				},
				{
					label: '计划八',
					prop: 'plan8',
				},
				{
					label: '计划九',
					prop: 'plan9',
				},
				{
					label: '计划十',
					prop: 'plan10',
				},
			],
		},
	],
}

// 美亚险投保方案
export const optionPlanMyC = {
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '保障利益',
			prop: 'insuredItem',
			width: 300,
		},
		{
			label: '各被保险人的保险金额（人民币：元）',
			children: [
				{
					label: '计划一',
					prop: 'plan1',
					html: true,
					formatter: ({plan1}) => {
						if (!plan1.includes('；')) {
							return plan1
						}
						let tempPlan = plan1.split('；')
						return tempPlan[0] + '</br>' + tempPlan[1]
					},
				},
				{
					label: '计划二',
					prop: 'plan2',
				},
				{
					label: '计划三',
					prop: 'plan3',
				},
				{
					label: '计划四',
					prop: 'plan4',
				},
				{
					label: '计划五',
					prop: 'plan5',
				},
				{
					label: '计划六',
					prop: 'plan6',
				},
				{
					label: '计划七',
					prop: 'plan7',
				},
				{
					label: '计划八',
					prop: 'plan8',
				},
				{
					label: '计划九',
					prop: 'plan9',
				},
				{
					label: '计划十',
					prop: 'plan10',
				},
			],
		},
	],
}

// 前海投保方案
export const optionPlanQh = {
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	header: false,
	column: [
		{
			label: '保障项目',
			prop: 'insuredItem',
			width: 240,
		},
		{
			label: '方案一',
			prop: 'plan1',
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
		{
			label: '方案三',
			prop: 'plan3',
		},
		{
			label: '方案四',
			prop: 'plan4',
		},
		{
			label: '方案五',
			prop: 'plan5',
		},
		{
			label: '方案六',
			prop: 'plan6',
		},
		{
			label: '方案七',
			prop: 'plan7',
		},
		{
			label: '方案八',
			prop: 'plan8',
		},
	],
}
// 阳光驾乘投保方案
export const optionPlanYgjc = {
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	header: false,
	column: [
		{
			label: '保障项目',
			prop: 'insuredItem',
			width: 240,
		},
		{
			label: '方案一',
			prop: 'plan1',
			html: true,
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
		{
			label: '方案三',
			prop: 'plan3',
		},
		{
			label: '方案四',
			prop: 'plan4',
		},
	],
}

//新市民保费
export const optionPremiumXsm = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	expandLevel: 3,
	headerAlign: 'center',
	align: 'center',
	tree: true,
	column: [
		{
			label: '方案',
			children: [
				{
					label: '职业分类',
					prop: 'insuredTerm',
				},
			],
		},
		{
			label: '30万',
			children: [
				{
					label: '1-3类',
					prop: 'plan30_1',
				},
				{
					label: '4-5类',
					prop: 'plan30_2',
				},
				{
					label: '其他6类',
					prop: 'plan30_3',
				},
			],
		},
		{
			label: '50万',
			children: [
				{
					label: '1-3类',
					prop: 'plan50_1',
				},
				{
					label: '4-5类',
					prop: 'plan50_2',
				},
				{
					label: '其他6类',
					prop: 'plan50_3',
				},
			],
		},
		{
			label: '80万',
			children: [
				{
					label: '1-3类',
					prop: 'plan80_1',
				},
				{
					label: '4-5类',
					prop: 'plan80_2',
				},
				{
					label: '其他6类',
					prop: 'plan80_3',
				},
			],
		},
		{
			label: '100万',
			children: [
				{
					label: '1-3类',
					prop: 'plan100_1',
				},
				{
					label: '4-5类',
					prop: 'plan100_2',
				},
				{
					label: '其他6类',
					prop: 'plan100_3',
				},
			],
		},
		{
			label: '120万',
			children: [
				{
					label: '1-3类',
					prop: 'plan120_1',
				},
				{
					label: '4-5类',
					prop: 'plan120_2',
				},
				{
					label: '其他6类',
					prop: 'plan120_3',
				},
			],
		},
	],
}

//保费
export const optionPremium = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	expandLevel: 3,
	headerAlign: 'center',
	align: 'center',
	tree: true,
	column: [
		{
			label: '方案',
			children: [
				{
					label: '职业分类',
					prop: 'insuredTerm',
				},
			],
		},
		{
			label: '30万',
			children: [
				{
					label: '4-5类',
					prop: 'plan30_1',
				},
				{
					label: '其他6类',
					prop: 'plan30_2',
				},
			],
		},
		{
			label: '50万',
			children: [
				{
					label: '4-5类',
					prop: 'plan50_1',
				},
				{
					label: '其他6类',
					prop: 'plan50_2',
				},
			],
		},
		{
			label: '80万',
			children: [
				{
					label: '4-5类',
					prop: 'plan80_1',
				},
				{
					label: '其他6类',
					prop: 'plan80_2',
				},
			],
		},
		{
			label: '100万',
			children: [
				{
					label: '4-5类',
					prop: 'plan100_1',
				},
				{
					label: '其他6类',
					prop: 'plan100_2',
				},
			],
		},
		{
			label: '120万',
			children: [
				{
					label: '4-5类',
					prop: 'plan120_1',
				},
				{
					label: '其他6类',
					prop: 'plan120_2',
				},
			],
		},
	],
}

export const optionPremiumDoor = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	expandLevel: 3,
	headerAlign: 'center',
	align: 'center',
	tree: true,
	column: [
		{
			label: '方案',
			prop: 'insuredTerm',
		},
		{
			label: '30万',
			prop: 'plan30',
		},
		{
			label: '50万',
			prop: 'plan50',
		},
		{
			label: '80万',
			prop: 'plan80',
		},
		{
			label: '100万',
			prop: 'plan100',
		},
	],
}

//受限工种
export const optionPremiumRestrict = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	expandLevel: 3,
	headerAlign: 'center',
	align: 'center',
	tree: true,
	column: [
		{
			label: '方案',
			prop: 'insuredTerm',
		},
		{
			label: '30万',
			prop: 'plan30',
		},
		{
			label: '50万',
			prop: 'plan50',
		},
		{
			label: '80万',
			prop: 'plan80',
		},
		{
			label: '100万',
			prop: 'plan100',
		},
		{
			label: '120万',
			prop: 'plan120',
		},
	],
}

//赔付标准
export const optionBenefit = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '等级',
			prop: 'levelItem',
		},
		{
			label: '10级',
			prop: 'level10',
		},
		{
			label: '9级',
			prop: 'level9',
		},
		{
			label: '8级',
			prop: 'level8',
		},
		{
			label: '7级',
			prop: 'level7',
		},
		{
			label: '6级',
			prop: 'level6',
		},
		{
			label: '5级',
			prop: 'level5',
		},
		{
			label: '4级',
			prop: 'level4',
		},
		{
			label: '3级',
			prop: 'level3',
		},
		{
			label: '2级',
			prop: 'level2',
		},
		{
			label: '1级',
			prop: 'level1',
		},
	],
}

//短期方案
export const optionDq = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '1月',
			prop: 'prop1',
		},
		{
			label: '2月',
			prop: 'prop2',
		},
		{
			label: '3月',
			prop: 'prop3',
		},
		{
			label: '4月',
			prop: 'prop4',
		},
		{
			label: '5月',
			prop: 'prop5',
		},
		{
			label: '6月',
			prop: 'prop6',
		},
		{
			label: '7月',
			prop: 'prop7',
		},
		{
			label: '8月',
			prop: 'prop8',
		},
		{
			label: '9月',
			prop: 'prop9',
		},
		{
			label: '10月',
			prop: 'prop10',
		},
		{
			label: '11月',
			prop: 'prop11',
		},
	],
}

//批增费率
export const optionAddFeeRateGang6 = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '批增月份',
			prop: 'category',
		},
		{
			label: '1个月',
			prop: 'month1',
		},
		{
			label: '2个月',
			prop: 'month2',
		},
		{
			label: '3个月',
			prop: 'month3',
		},
		{
			label: '4个月',
			prop: 'month4',
		},
		{
			label: '5个月',
			prop: 'month5',
		},
	],
}

//批增费率
export const optionAddFeeRate = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '职业类别',
			prop: 'category',
			hide: false,
		},
		{
			label: '1个月',
			prop: 'month1',
		},
		{
			label: '2个月',
			prop: 'month2',
		},
		{
			label: '3个月',
			prop: 'month3',
		},
		{
			label: '4个月',
			prop: 'month4',
		},
		{
			label: '5个月',
			prop: 'month5',
		},
		{
			label: '6个月',
			prop: 'month6',
		},
		{
			label: '7个月',
			prop: 'month7',
		},
		{
			label: '8个月',
			prop: 'month8',
		},
		{
			label: '9个月',
			prop: 'month9',
		},
		{
			label: '10个月',
			prop: 'month10',
		},
		{
			label: '11个月',
			prop: 'month11',
		},
	],
}

export const optionShortPeriodRate = {
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	header: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '1个月',
			prop: 'month1',
		},
		{
			label: '2个月',
			prop: 'month2',
		},
		{
			label: '3个月',
			prop: 'month3',
		},
		{
			label: '4个月',
			prop: 'month4',
		},
		{
			label: '5个月',
			prop: 'month5',
		},
		{
			label: '6个月',
			prop: 'month6',
		},
		{
			label: '7个月',
			prop: 'month7',
		},
		{
			label: '8个月',
			prop: 'month8',
		},
		{
			label: '9个月',
			prop: 'month9',
		},
		{
			label: '10个月',
			prop: 'month10',
		},
		{
			label: '11个月',
			prop: 'month11',
		},
		{
			label: '12个月',
			prop: 'month12',
		},
	],
}
//短期保费=年保费*比例
export const optionTKDQ = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '月份',
			prop: 'levelItem',
		},
		{
			label: '1个月',
			prop: 'level1',
		},
		{
			label: '2个月',
			prop: 'level2',
		},
		{
			label: '3个月',
			prop: 'level3',
		},
		{
			label: '4个月',
			prop: 'level4',
		},
		{
			label: '5个月',
			prop: 'level5',
		},
		{
			label: '6个月',
			prop: 'level6',
		},
		{
			label: '7个月',
			prop: 'level7',
		},
		{
			label: '8个月',
			prop: 'level8',
		},
		{
			label: '9个月',
			prop: 'level9',
		},
		{
			label: '10个月',
			prop: 'level10',
		},
		{
			label: '11个月',
			prop: 'level11',
		},
		{
			label: '12个月',
			prop: 'level12',
		},
	],
}

// 泰康在线详情option
export const optionTaiKangDT = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '项目',
			prop: 'insuredItem',
		},
		{
			label: '方案一',
			prop: 'plan1',
			html: true,
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
		{
			label: '方案三',
			prop: 'plan3',
		},
	],
}

//家电
// 投保方案
export const optionPlanJiaDian = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '保障项目',
			prop: 'insuredItem',
		},
		{
			label: '方案一',
			prop: 'plan1',
			html: true,
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
		{
			label: '方案三',
			prop: 'plan3',
		},
		{
			label: '方案四',
			prop: 'plan4',
		},
	],
}

// 投保方案
export const optionPlanJiaDian_short = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '保障项目',
			prop: 'insuredItem',
		},
		{
			label: '方案一',
			prop: 'plan1',
			html: true,
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
	],
}

export const optionPlanXsmJianZao = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '保障项目',
			prop: 'insuredItem',
		},
		{
			label: '方案一',
			prop: 'plan1',
			html: true,
		},
		{
			label: '方案二',
			prop: 'plan2',
		},
		{
			label: '方案三',
			prop: 'plan3',
		},
		{
			label: '方案四',
			prop: 'plan4',
		},
		{
			label: '方案五',
			prop: 'plan5',
		},
	],
}

//交通运输
export const optionPlanXsmYunShu = {
	header: false,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	showHeader: false,
	headerAlign: 'center',
	align: 'center',
	column: [
		{
			label: '',
			prop: 'plan0',
		},
		{
			label: '',
			prop: 'plan1',
		},
		{
			label: '',
			prop: 'plan2',
		},
		{
			label: '',
			prop: 'plan3',
		},
		{
			label: '',
			prop: 'plan4',
		},
	],
}
